import { render, staticRenderFns } from "./DatacenterProxies.vue?vue&type=template&id=18e2b329&scoped=true"
import script from "./DatacenterProxies.vue?vue&type=script&lang=js"
export * from "./DatacenterProxies.vue?vue&type=script&lang=js"
import style0 from "./DatacenterProxies.vue?vue&type=style&index=0&id=18e2b329&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e2b329",
  null
  
)

export default component.exports